// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"19":"blog","353":"contact","420":"message","462":"legal","597":"projects","604":"company","757":"not-found"}[chunkId] + "." + {"19":"6f0e043a","353":"d15d50dc","420":"20c4463f","462":"8639e268","597":"ac39eee1","604":"e63d2445","757":"34d53a9d"}[chunkId] + ".css";
};